/**
 * @file: UserWeixinBindingType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum UserWeixinBindingType {
  Mp = 'mp',
  Open = 'open',
  App = 'app',
  Mobile = 'mobile',
}

export const UserWeixinBindingTypeValueSet = new Set([
  UserWeixinBindingType.Mp,
  UserWeixinBindingType.Open,
  UserWeixinBindingType.App,
  UserWeixinBindingType.Mobile,
]);
